module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/55b5fb66d32f05f6fbcb0995a71e64c2.png";